module.exports = __webpack_public_path__ + "img/zs6.09c6a292.jpg";